var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagicWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M805.89 70.41l-644.68 768.3c-5.84 6.96-4.91 17.55 2.04 23.39l111.57 93.62c6.96 5.84 17.31 4.71 23.15-2.25l644.68-768.3c5.84-6.96 5.15-17.35-1.8-23.19L829.28 68.36c-6.96-5.84-17.55-4.91-23.39 2.05z m94.61 105.56l-189.05 225.3-78.22-65.64 189.05-225.31 78.22 65.65zM325.65 166.53l26.32 85.33 85.33 26.32-85.33 26.31-26.32 85.34-26.31-85.34-85.33-26.31 85.33-26.32zM551.99 110.33l12.05 39.1 39.1 12.06-39.1 12.06-12.05 39.1-12.06-39.1-39.1-12.06 39.1-12.06zM114.8 95.67l12.06 39.1 39.1 12.06-39.1 12.05-12.06 39.1-12.05-39.1-39.1-12.05 39.1-12.06zM909.2 360.91l12.05 39.1 39.1 12.06-39.1 12.06-12.05 39.1-12.06-39.1-39.1-12.06 39.1-12.06z",
    fill: "#6C6D6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.0f7430053ffd1c0143b64ed45cfc1fad.svg";
export { ForwardRef as ReactComponent };